<template>
  <v-container>
    <h1 class="pt-3 pb-5">Magby Admin</h1>
    <template v-if="role === 'ADMIN'">
      <v-data-table
        :headers="headers"
        :items-per-page="-1"
        :items="terminals"
        hide-default-footer
        class="elevation-0"
        item-key="name"
        v-if="windowWidth > 768"
      >
        <template v-slot:[`item.name`]="{ item }">
          <div class="table-terminal-name">
            <span>
              {{ item.name }}
            </span>
            <span>
              {{ `(v${item.version})` }}
            </span>
          </div>
        </template>
        <template v-slot:[`item.printer.inkRemain`]="{ item }">
          {{ item.printer.inkRemain + "%" }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu
            bottom
            :close-on-click="true"
            origin="center right"
            transition="slide-y-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <div class="d-flex align-center justify-end">
                <v-btn v-bind="attrs" v-on="on" icon>
                  <v-icon class="ml-1 mr-1">
                    {{ "more_vert" }}
                  </v-icon>
                </v-btn>
              </div>
            </template>
            <v-list style="min-width: 230px">
              <v-list-item
                dense
                link
                @click="
                  (printer.modal = true),
                    (printer.text = item.printer.text),
                    (printer.terminal = item.name)
                "
              >
                <v-list-item-action class="mr-4">
                  <v-icon dense>
                    {{ "print" }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-title>Printer Status</v-list-item-title>
              </v-list-item>
              <v-list-item
                dense
                link
                @click="(modalData = item), (dialog = true), (paperValue = '300')"
              >
                <v-list-item-action class="mr-4">
                  <v-icon dense>
                    {{ "post_add" }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-title>Remain paper</v-list-item-title>
              </v-list-item>
              <v-list-item
                dense
                link
                @click="(refreshValue = item.name), (confirm = true)"
              >
                <v-list-item-action class="mr-4">
                  <v-icon dense>
                    {{ "refresh" }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-title>Reboot</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`item.temperature`]="{ item }">
          {{ item.temperature ? item.temperature + "℉" : "-" }}
        </template>
        <template v-slot:[`item.printer`]="{ item }">
          <span :style="{ color: item.printer.status ? 'green' : 'red' }">{{
            item.printer.status ? "OK" : "ERROR"
          }}</span>
        </template>
        <template v-slot:[`item.websocket`]="{ item }">
          <span :style="{ color: item.websocket.status ? 'green' : 'red' }">{{
            item.websocket.status ? "OK" : "ERROR"
          }}</span>
        </template>
      </v-data-table>
      <v-list v-else dense class="elevation-2">
        <v-list-item v-for="(terminal, index) in terminals" :key="index">
          <v-list-item-content>
            <v-list-item-title>{{ terminal.name }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-row class="d-flex flex-row justify-end align-center">
              <span class="mr-3">{{ terminal.paper }}</span>
              <v-icon
                class="mr-4"
                :color="terminal.websocket.status ? 'green' : 'error'"
                >{{ terminal.websocket.status ? "wifi" : "wifi_off" }}</v-icon
              >
              <v-icon
                class="mr-2"
                :color="terminal.printer.status ? 'green' : 'error'"
                >{{
                  terminal.printer.status ? "print" : "print_disabled"
                }}</v-icon
              >
              <v-menu
                bottom
                :close-on-click="true"
                origin="center right"
                transition="slide-y-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon>
                    <v-icon class="ml-1 mr-1">
                      {{ "more_vert" }}
                    </v-icon>
                  </v-btn>
                </template>
                <v-list style="min-width: 230px">
                  <v-list-item
                    dense
                    link
                    @click="
                      (printer.modal = true),
                        (printer.text = terminal.printer.text),
                        (printer.terminal = terminal.name)
                    "
                  >
                    <v-list-item-action class="mr-4">
                      <v-icon dense>
                        {{ "print" }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-title>Printer Status</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    dense
                    link
                    @click="
                      (modalData = terminal),
                        (dialog = true),
                        (paperValue = '300')
                    "
                  >
                    <v-list-item-action class="mr-4">
                      <v-icon dense>
                        {{ "post_add" }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-title>Remain paper</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    dense
                    link
                    @click="(refreshValue = terminal.name), (confirm = true)"
                  >
                    <v-list-item-action class="mr-4">
                      <v-icon dense>
                        {{ "refresh" }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-title>Reboot</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-dialog v-model="confirm" max-width="390">
        <v-card>
          <v-card-title class="text-h5">
            Reboot {{ refreshValue }}?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="confirm = false"> Cancel </v-btn>
            <v-btn color="primary" @click="submit"> Submit </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="printer.modal" max-width="400">
        <v-card>
          <v-card-title class="text-h5">
            {{ printer.terminal }} printer status:
          </v-card-title>
          <v-card-text>
            <p>{{ printer.text }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="printer.modal = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog" max-width="700">
        <v-card v-if="modalData">
          <v-card-title class="headline">
            {{ modalData.name }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="mt-2">
            <v-container>
              <v-text-field
                v-model="paperValue"
                label="Paper"
                type="number"
                dense
              ></v-text-field>
              <v-btn
                color="primary"
                @click="(dialog = false), resetPaper(modalData.name)"
                width="100%"
              >
                Reset
              </v-btn>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="snackbar" :timeout="3000">
        {{ text }}
      </v-snackbar>
    </template>
    <template v-else>
      <p>Welcome to admin panel!</p>
      <v-btn color="primary" @click="$router.push('statistics')">
        Sales statistics
        <v-icon right>
          mdi-open-in-new
        </v-icon>
      </v-btn>
    </template>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "Home",
  components: {
    // Title,
  },
  data: () => ({
    terminals: [],
    refreshValue: "",
    headers: [
      {
        text: "ID",
        align: "start",
        sortable: false,
        value: "id",
        width: "8%",
      },
      { text: "Name", value: "name" },
      { text: "Online", value: "websocket", sortable: false, width: "10%" },
      { text: "Printer", value: "printer", sortable: false, width: "10%" },
      { text: "Paper", value: "paper", width: "8%" },
      { text: "Ink remain", value: "printer.inkRemain", width: "10%" },
      { text: "", value: "actions", width: "5%", sortable: false },
    ],
    confirm: false,
    snackbar: false,
    text: "",
    printer: {
      modal: false,
      terminal: "",
      text: "",
    },
    dialog: false,
    modalData: null,
    paperValue: "300",
    windowWidth: 0,
  }),
  computed: {
    ...mapGetters('user', ["role"]),
  },
  methods: {
    submit() {
      this.$http
        .post("/rest/reboot/" + this.refreshValue)
        .then((res) => {
          this.snackbar = true;
          this.confirm = false;
          this.text = res.data.message;
        })
        .catch((err) => {
          this.snackbar = true;
          this.confirm = false;
          this.text = err.response.data.message;
        });
    },
    getStatuses() {
      if (this.role == "ADMIN") {
        this.$http.get("/rest/terminals/status").then((res) => {
          this.terminals = res.data.reverse();
        });
      }
    },
    resetPaper(terminal) {
      this.$http
        .post("/rest/paper/" + terminal, { paper: this.paperValue })
        .then(() => {
          this.getStatuses();
        });
    },
    windowSizeUpdate() {
      this.windowWidth = window.innerWidth;
    },
  },
  mounted() {
    this.windowWidth = window.innerWidth;
    this.getStatuses();
    window.addEventListener("resize", this.windowSizeUpdate);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.windowSizeUpdate);
  },
};
</script>

<style scoped>
.paper {
  display: flex;
  justify-content: flex-start;
  width: 36px;
  align-items: center;
  line-height: 36px;
}

.table-terminal-name {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.table-terminal-name span:last-child {
  color: #9d9d9d;
  font-size: 12px;
}
</style>
